import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { Observable } from 'rxjs';

import { DotCmsFacade } from '../../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../../models/contentlet/custom-dotcms-contentlet.model';

@Component({
  selector: 'custom-dot-cms-blog-detail',
  templateUrl: './dot-cms-blog-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-blog-detail.component.scss'],
  standalone: false,
})
export class DotCmsBlogDetailComponent implements OnInit {
  previousUrl$: Observable<string>;
  readonly contentlet = input<CustomDotCmsContentlet>(undefined);
  readonly identifier = input<string>(undefined);
  constructor(private dotCmsFacade: DotCmsFacade) {}
  ngOnInit() {
    this.previousUrl$ = this.dotCmsFacade.getPreviousUrl();
  }
  buildImageSrc(imageKey: string) {
    return this.dotCmsFacade.generateImageURIFromImageKey(this.identifier(), imageKey);
  }
  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
  }
}
